import { pickBy, get } from 'lodash';
import { formatDate } from './common';
import ApiConstants from '../../config/apiConstants';
import { TYPE_IFT, TYPE_CHAPS } from '../../config';

export const getPreBookedInformation = (payment) => {
	if (payment.isPreBookedRate) {
		return {
			pre_booked: {
				reference: payment.preBookedReference,
				rate: Number(get(payment, 'exchangeRate', '').toString().replace(/,/g, '')),
			},
		};
	}
	return {};
};

export const getAmountToSend = (payment) => {
	const currency = payment.isSendAmountFromDebitCurrency
		? get(payment, 'fromAccountCurrency')
		: get(payment, 'sendCurrency');
	return {
		amount: {
			value: Number(payment.sendAmount.replace(/,/g, '')),
			currency,
		},
	};
};

export const deriveIndicativeState = (payment) => {
	const indicative = get(payment, 'authorisation.status');
	return indicative === ApiConstants.obligate;
};

const getBeneficiary = (payee) =>
	pickBy({
		name: get(payee, 'to_account.name'),
		account_number: get(payee, 'to_account.account_number'),
		sort_code: get(payee, 'to_account.sort_code'),
		iban: get(payee, 'to_account.iban', '').toUpperCase(),
		bic: get(payee, 'to_account.bic', '').toUpperCase(),
		clearing_code: get(payee, 'to_account.clearing_code'),
		reference_high_value: payee.reference_high_value,
		address: payee.address,
		bank: payee.bank,
	});

// TODO: used by IFT only at the moment, need to refactor
export const getExchangeRateRequest = (payment, payee) => ({
	payment_type: TYPE_IFT,
	indicative: true,
	payments: [
		{
			source_id: payment.id,
			debit_account: payment.fromAccount,
			debit_account_currency: payment.fromAccountCurrency,
			send_currency: payment.sendCurrency,
			payment_date: formatDate(payment.date),
			charging_model: payment.chargingModal,
			urgent: payment.urgent,
			beneficiary: getBeneficiary(payee),
			...getAmountToSend(payment),
			...getPreBookedInformation(payment),
		},
	],
});

// used by CHAPS only at the moment
export const buildRatePayment = (payment, payee) => ({
	payment_type: TYPE_CHAPS,
	indicative: deriveIndicativeState(payment),
	payments: [
		{
			source_id: payment.id,
			debit_account: payment.fromAccount,
			debit_account_currency: 'GBP',
			send_currency: 'GBP',
			payment_date: formatDate(payment.date),
			amount: {
				value: parseFloat(payment.amount.replace(/,/g, '')),
				currency: 'GBP',
			},
			charging_model: 'DEBT',
			urgent: true,
			beneficiary: getBeneficiary(payee),
		},
	],
});
